import { createAction, props } from "@ngrx/store"

export const storeMenuItems = createAction(
    '[Menu] Store menu items',
    props<{ userRoles: string[] }>()
)